import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getCustomerServiceDetails = () => {
  const url = API_URLS.customerServiceApi;
  return axiosClient.get(url);
};
